# Try It This Week

**The 3-Day Challenge**

1. Install Ollama (`brew install ollama`) or LM Studio
2. Download one model: `ollama pull qwen3:4b` or `ollama pull gemma3n:e4b`
3. Use it for real work — code review, docs, or exploration

---

**Share & Learn**

Post your experience in #guild-ai — wins, surprises, questions, gotchas

**Resources**

- lmstudio.ai — Easy GUI for beginners
- ollama.com — CLI tool for power users
- huggingface.co — Browse models and benchmarks
- youtube.com/@Fireship — Great tech explainers and tutorials

---

**Questions?**